<template>
  <MainLayoutV2 section="bug">
    <div id="bug_container">
      <div id="bug">
        <h1>{{loading}}</h1>

        <iframe id="bug_iframe"
          src="https://www.cognitoforms.com/f/V8H4nnexk0GkSoBj9W0QXw/6"
          style="border:0;width:100%;" height="660"
          @load="on_load">
	</iframe>
      </div>
    </div>
  </MainLayoutV2>
</template>

<script>
import MainLayoutV2 from '@/components/V2/layout/MainLayoutV2'

export default {
  name: 'BugV2',
  components: {
    MainLayoutV2
  },

  data : function(){
    return {
      loading : 'Loading...'
    }
  },

  computed : {
    width : function(){
      if(this.mq_gt_md)
        return 720;
      else if(this.mq_md)
        return 620;
      else if(this.mq_sm)
        return 520;
      else
        return 320;
    },

    height : function(){
      if(this.mq_gt_md)
        return 1175;
      else if(this.mq_md)
        return 1250;
      else if(this.mq_sm)
        return 1350;
      else
        return 1750;
    }
  },

  methods : {
    on_load : function(){
      this.loading = "";
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#bug_container{
  padding: 150px 0 75px 0;
}

#bug{
  border-radius: 15px;
  width: 700px;
  margin: 5px auto;
}

#bug h1{
  color: white;
  text-align: center;
}

#main_layout_v2.md #bug{
  width: 620px;
}

#main_layout_v2.sm #bug{
  width: 500px;
}

#main_layout_v2.xs #bug{
  width: 320px;
}
</style>
